import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/es';
import Sound from '../components/Sound';
import AsistenteConfiguracionInicial from '../components/AsistenteConfiguracionInicial';
import Home from '../pages/Home';
import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';

import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';

import banner_platinium from '../tools/images/Banner membresía Platinum.svg'
import banner_golde from '../tools/images/Banner membresía golden.svg'
import banner_diamond from '../tools/images/Banner membresía diamond.svg'

import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

import  * as signalR from '@aspnet/signalr';
import img from '../tools/images/logomedicall24horizontal.svg';
import '../tools/css/Navbar.css';


const ApiURL=process.env.REACT_APP_API_URL;
const Token =sessionStorage.getItem('token');
var cod_mebre=sessionStorage.getItem('codigo');

// "/api/Notifications/ListAll" no pagina en el backend: trae todo el listado de una vez.
// Por eso el paginado del panel es del lado del cliente, revelando de a poco lo ya cargado.
const NOTIFICACIONES_POR_PAGINA = 15;

//permite validar el token para las conexiones con axios
axios.interceptors.request.use(
  config =>{
    config.headers.authorization = `Bearer ${Token}`;
    return config;
  },
  error =>{
    return Promise.reject(error);
  }
)
         

    class Navbar extends Component  {

      constructor()
    {
     super()
      this.state={
        show:false,
        Notification: [],
        paginaNotificaciones: 1,
        cargandoNotificaciones: false,
        notificacionesExpandidas: {},
        acepta:'',
        SignalrMessage:'',
        msg1:'',
        msg2:'',
        num:'',
        estado_sonido:true,
       
        form:{   
        id_soli_acep:'',     
        id_pacie_acep:'',
        nom_pcte_acep:'',
        descrip:''        
        
        }
        
      }
    }


    SolicitudesURG(){

      const protocol = new signalR.JsonHubProtocol();
      const SignalRconnection = new signalR.HubConnectionBuilder()
      .withUrl(ApiURL+'/api/notifications', 
      {
          accessTokenFactory: () => Token
      }) 
      .withHubProtocol(protocol)    
      .build();
      this.setState({SignalRconnection}, () =>{
        this.state.SignalRconnection.start()
        .then(() =>console.log('Conexion iniciada'))
        .catch(err =>console.log('Error de Conexion signalR'))

        this.state.SignalRconnection.on("ShowNotification", (message) => {
         const SignalrMessage = message.split('-');
         const msg1=SignalrMessage[0];
         const msg2=SignalrMessage[1];
         const num=msg1.split('-').length;

         console.log( SignalrMessage);         
         this.setState({msg1});
         this.setState({msg2});
         this.setState({num});

        
         this.Notification(); 
         this.setState({estado_sonido:this.state.estado_sonido = true})
         

                  
         store.addNotification({
          title: msg1,
          message: msg2,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ estado_sonido: this.state.estado_sonido = false })

      });
             
      })

    }

      componentDidMount(){
        
        if(cod_mebre!='null'){
          window.location.href="/activationMembership";
        }else{
  
          if(!sessionStorage.getItem('token')){
            window.location.href="/";
          }
  
        }

        this.SolicitudesURG();        
      
      
    
    }


    Notification(){
      this.setState({cargandoNotificaciones: true})
      axios.get(ApiURL+"/api/Notifications/ListAll")
      .then((response) => {
        console.log(response);
        this.setState({Notification: response.data, paginaNotificaciones: 1, cargandoNotificaciones: false})

      })
      .catch((error) => {
        console.log(error);
        this.setState({cargandoNotificaciones: false})
      })

    }

    /** Revela la siguiente tanda de notificaciones ya cargadas (paginado del lado del cliente). */
    cargarMasNotificaciones = () => {
      this.setState((previo) => {
        const totalVisible = previo.paginaNotificaciones * NOTIFICACIONES_POR_PAGINA
        if (totalVisible >= previo.Notification.length) return null
        return { paginaNotificaciones: previo.paginaNotificaciones + 1 }
      })
    }

    /** Dispara la carga de la siguiente página cuando el scroll del panel llega casi al final. */
    manejarScrollNotificaciones = (evento) => {
      const el = evento.target
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 40) {
        this.cargarMasNotificaciones()
      }
    }

    /** Expande/colapsa el texto completo de una notificación sin cerrar el dropdown. */
    toggleNotificacionExpandida = (indice, evento) => {
      evento.preventDefault()
      evento.stopPropagation()
      this.setState((previo) => ({
        notificacionesExpandidas: {
          ...previo.notificacionesExpandidas,
          [indice]: !previo.notificacionesExpandidas[indice]
        }
      }))
    }

    
    
  render(){

    const notificacionesVisibles = this.state.Notification.slice(0, this.state.paginaNotificaciones * NOTIFICACIONES_POR_PAGINA)
    const hayMasNotificaciones = notificacionesVisibles.length < this.state.Notification.length

    return(

    <React.Fragment>

    <AsistenteConfiguracionInicial/>

    <nav className="main-header navbar navbar-expand navbar-white navbar-light navbar-pro">

      {this.state.sound_notification}

      {/* Left navbar links */}
      <ul className="navbar-nav navbar-pro__left">
        <li className="nav-item">
          <a className="nav-link navbar-pro__toggle" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars" /></a>
        </li>
        <a  href="/inicio_profesional" className="navbar-brand navbar-pro__brand"> <img src={img} alt="logo" className="navbar-pro__logo"/> </a>

      </ul>

        {/* SEARCH FORM */}


        {/* Right navbar links */}
      <ul className="navbar-nav ml-auto navbar-pro__right">

        <li className="nav-item dropdown">

          <a className="nav-link navbar-pro__ayuda" href="https://medicall24.com.co/pqrs/"  target="_blank" rel="noopener noreferrer">

            <i className="fas fa-question-circle" id="link_pqrs"></i><span className="navbar-pro__ayuda-texto"><b>Ayuda</b></span>

          </a>

        </li>


        <li className="nav-item dropdown" onClick={()=>{this.Notification()}}>

          <a className="nav-link navbar-pro__bell" data-toggle="dropdown" href="#">

            <i className="far fa-bell fa-lg" />
            <span className="badge badge-danger navbar-badge">{this.state.num}</span>
            {this.state.estado_sonido?false:<Sound/>}
          </a>

          <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right notif-panel">

            <div className="notif-panel__header">
              <span>Notificaciones</span>
              {this.state.Notification.length > 0 ? <span className="notif-panel__count">{this.state.Notification.length}</span> : null}
            </div>

            <div className="notif-panel__list" onScroll={this.manejarScrollNotificaciones}>
              {this.state.cargandoNotificaciones ? (
                <div className="notif-panel__loading">
                  <i className="fas fa-circle-notch fa-spin"></i>
                  <span>Cargando notificaciones...</span>
                </div>
              ) : this.state.Notification.length === 0 ? (
                <div className="notif-panel__empty">
                  <i className="far fa-bell-slash"></i>
                  <span>No tienes notificaciones</span>
                </div>
              ) : (
                <React.Fragment>
                  {notificacionesVisibles.map((noty, indice) => {
                    const expandida = !!this.state.notificacionesExpandidas[indice]
                    const esLarga = (noty.message || '').length > 90
                    return (
                    <div className="notif-item" key={indice}>
                      <span className="notif-item__icon"><i className="far fa-bell"></i></span>
                      <div className="notif-item__body">
                        <span className="notif-item__title">{noty.title}</span>
                        <span className={"notif-item__message" + (esLarga && !expandida ? " notif-item__message--clamp" : "")}>{noty.message}</span>
                        {esLarga ? (
                          <span className="notif-item__vermas" onClick={(e)=>this.toggleNotificacionExpandida(indice, e)}>{expandida ? "Ver menos" : "Ver más"}</span>
                        ) : null}
                        <span className="notif-item__time"><i className="far fa-clock"></i> <Moment fromNow locale='es'>{noty.date}</Moment></span>
                      </div>
                    </div>
                    )
                  })}
                  {hayMasNotificaciones ? (
                    <div className="notif-panel__loading-more">
                      <i className="fas fa-circle-notch fa-spin"></i> Cargando más...
                    </div>
                  ) : null}
                </React.Fragment>
              )}
            </div>

          </div>

        </li>
    
      </ul>

    </nav>

    </React.Fragment>

    )
  }

}

export default Navbar;